import axiosIns from '@/libs/axios'

const controller = 'schooling'

export default {
  async getAll() {
    return axiosIns.get(controller).then(res => res.data)
  },
}
